import React, { memo, useEffect, useState } from 'react';
import { DatePicker as OldDatePicker } from 'antd-mobile';
import { translationByCallBack } from 'config/language/context';

// Picker HOC 转换多语言
const Dom = memo((props) => {
  const {
    title, // String 大标题
    okText, // String 选中的文案 默认为确定
    dismissText, // String 取消选中的文案 默认为取消
    ...restProps
  } = props;

  const [newTitle, setNewTitle] = useState(title);
  const [newOkText, setNewOkText] = useState(okText);
  const [newDismissText, setNewDismissText] = useState(dismissText);

  useEffect(() => {
    translationByCallBack(title, setNewTitle);
  }, [title]);

  useEffect(() => {
    translationByCallBack(okText, setNewOkText);
  }, [okText]);

  useEffect(() => {
    translationByCallBack(dismissText, setNewDismissText);
  }, [dismissText]);

  return (
    <OldDatePicker
      title={newTitle}
      okText={newOkText}
      dismissText={newDismissText}
      {...restProps}
    />
  );
});

const DatePicker = memo((props) => {
  const {
    okText, // String 选中的文案 默认为确定
    dismissText, // String 取消选中的文案 默认为取消
    title, // String | ReactNode 大标题
    ...restProps
  } = props;

  const renderTitle = () => {
    if (typeof title == 'string') {
      return (
        <div>
          <span className="ellipsis-one">{title}</span>
        </div>
      );
    }
    return title;
  };

  const getTitle = renderTitle();

  return (
    <Dom
      okText={props.newOkText || '确定'}
      dismissText={props.newDismissText || '取消'}
      title={getTitle}
      {...restProps}
    />
  );
});

export default DatePicker;



// WEBPACK FOOTER //
// ./src/widget/DatePicker/index.js